import React, { useEffect } from 'react';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import styled from 'styled-components';

// Define the type for overlayInnerStyle
type OverlayInnerStyleType = React.CSSProperties & {
    flexWrap?: string;
};

const TooltipWrapper = styled.div`
    .custom-tooltip .ant-tooltip-arrow-content {
        background-color: #fff !important
    }
`;

const overlayInnerStyle: OverlayInnerStyleType = {
    maxWidth: '524px',
    width: 'max-content',
    maxHeight: '142px',
    overflow: 'auto',
    display: 'flex',
    flexWrap: 'wrap', // You can specify individual CSS properties with their respective types
    padding: '8px',
    columnGap: '8px',
    rowGap: '4px',
    borderRadius: '8px'
};

const placementMap: Record<string, TooltipPlacement> = {
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right',
    topLeft: 'topLeft',
    topRight: 'topRight',
    bottomLeft: 'bottomLeft',
    bottomRight: 'bottomRight',
};

const Title = styled.div`
color: #1EC252;
font-family: Roboto;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 20px;
cursor: pointer;
@media (max-width: 1439px) {
    font-size: 13px;
  }
`

interface tooltopProp {
    reactChild: React.ReactNode;
    tooltipText: string,
    placement: string
}

const ToolTip: React.FC<tooltopProp> = ({ reactChild, tooltipText, placement }) => {
    const antdPlacement = placementMap[placement] || 'top';
    useEffect(() => {
        document.documentElement.scrollTop = document.documentElement.clientHeight;
        document.documentElement.scrollLeft = document.documentElement.clientWidth;
    }, []);

    return (
        <TooltipWrapper>
            <Tooltip trigger={'click'} placement={antdPlacement} color='#fff' overlayClassName='custom-tooltip' zIndex={1} overlayInnerStyle={overlayInnerStyle} title={reactChild}>
                <Title>{tooltipText}</Title>
            </Tooltip>
        </TooltipWrapper>
    );
};

export default ToolTip;